module.exports = __webpack_public_path__ + "img/miner2.32eb9dfc.png";